import { useCallback } from 'react';

const useSound = (muted) => {
  const playSound = useCallback((type) => {
    if (muted) return;
    
    try {
      const audioContext = new (window.AudioContext || window.webkitAudioContext)();
      const oscillator = audioContext.createOscillator();
      const gainNode = audioContext.createGain();
      
      oscillator.connect(gainNode);
      gainNode.connect(audioContext.destination);
      
      let frequency = 440; // Default A4
      let duration = 0.2;
      
      switch (type) {
        case 'start':
          frequency = 523.25; // C5
          duration = 0.3;
          break;
        case 'correct':
          frequency = 659.25; // E5
          duration = 0.2;
          break;
        case 'incorrect':
          // Create a descending "buzz" sound for incorrect answers
          frequency = 330; // E4
          duration = 0.4;
          oscillator.type = 'sawtooth'; // More harsh sound
          break;
        case 'complete':
          frequency = 880; // A5
          duration = 0.5;
          break;
        default:
          frequency = 440; // Default A4
          duration = 0.2;
          break;
      }
      
      oscillator.frequency.setValueAtTime(frequency, audioContext.currentTime);
      oscillator.type = 'sine';
      
      gainNode.gain.setValueAtTime(0.1, audioContext.currentTime);
      gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + duration);
      
      oscillator.start(audioContext.currentTime);
      oscillator.stop(audioContext.currentTime + duration);
    } catch (error) {
      console.log('Audio not supported or blocked');
    }
  }, [muted]);

  return playSound;
};

export default useSound;
